import { Plus } from '@/components/icons'

// Flight-log-specific bits that sit alongside the shared PRNTR Input rows
// (see components/ui/prntr-input.tsx for the row primitives themselves).

// "+ Add Approach" / "+ Add Defect" pill button
export function AddPillButton({ label, onClick }: { label: string; onClick: () => void }) {
  return (
    <button
      type="button"
      onClick={onClick}
      className="mt-2 flex w-fit items-center gap-1 rounded-lg bg-surface-L2 px-3 py-2.5 text-sm font-semibold text-content-brand-bold active:opacity-70"
    >
      <Plus className="size-4" />
      {label}
    </button>
  )
}
